import { MetricMode } from './types';

export const metricModes: MetricMode[] = ['ai Score', 'Manual Score'];
